/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListHistoricalAlarmActivationsRequest = {
  /**
   * Cursor to start from
   */
  cursor?: string | undefined;
  /**
   * Number of results to return per page
   */
  size?: number | undefined;
  agentId: string;
};

/** @internal */
export const ListHistoricalAlarmActivationsRequest$inboundSchema: z.ZodType<
  ListHistoricalAlarmActivationsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  cursor: types.optional(types.string()),
  size: types.number().default(30),
  agent_id: types.string(),
}).transform((v) => {
  return remap$(v, {
    "agent_id": "agentId",
  });
});
/** @internal */
export type ListHistoricalAlarmActivationsRequest$Outbound = {
  cursor?: string | undefined;
  size: number;
  agent_id: string;
};

/** @internal */
export const ListHistoricalAlarmActivationsRequest$outboundSchema: z.ZodType<
  ListHistoricalAlarmActivationsRequest$Outbound,
  z.ZodTypeDef,
  ListHistoricalAlarmActivationsRequest
> = z.object({
  cursor: z.string().optional(),
  size: z.number().int().default(30),
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function listHistoricalAlarmActivationsRequestToJSON(
  listHistoricalAlarmActivationsRequest: ListHistoricalAlarmActivationsRequest,
): string {
  return JSON.stringify(
    ListHistoricalAlarmActivationsRequest$outboundSchema.parse(
      listHistoricalAlarmActivationsRequest,
    ),
  );
}
export function listHistoricalAlarmActivationsRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListHistoricalAlarmActivationsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListHistoricalAlarmActivationsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListHistoricalAlarmActivationsRequest' from JSON`,
  );
}
